export default __webpack_public_path__ + "static/media/up-arrow-pink.3a4007f5.svg";